import React, { useEffect } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import { Link } from 'react-router-dom';

import { useQuery, useHttpStatus } from '~/commons/hooks';

import FormPwdReset from '../forms/FormPwdReset.jsx';
import AnimPending from '~/commons/components/AnimPending.jsx';

import meta from '~/commons/config/meta';
import PageNotFound from '../../../commons/components/PageNotFound.jsx';

const t = {
  en: {
    title: 'Change Password',
    expired: 'This link has expired',
    resend: 'Click here to resend',
  },
  'zh-Hant': {
    title: '更改密碼',
    expired: '此連結已過期',
    resend: '按此重發驗證碼',
  },
};
const PagePwdReset = () => {
  const [res, req] = useHttpStatus();
  const { key, lg = 'en' } = useQuery();
  if (lg !== 'zh-Hant' && lg !== 'en') {
    return (<PageNotFound />);
  }

  meta.set({ title: t[lg].title });

  useEffect(() => {
    if (key) {
      req({
        method: 'post',
        url: '/api/core/pwd-resets/verify',
        data: { key },
      });
    }
  }, [key]);

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-4">
          {res.status === 'pending' && <AnimPending />}
          {(!key || res.status === 'error') && (
            <div>
              <h1 className="text-danger">
                <FA icon={faExclamationCircle} />
              </h1>
              <h3>{t[lg].expired}</h3>
              <p>
                <Link to={`/auth/pwd-recovery?lg=${lg}`}>
                  {t[lg].resend}
                </Link>
              </p>
            </div>
          )}
          {res.status === 'success' && <FormPwdReset resetKey={key} />}
        </div>
      </div>
    </div>
  );
};

export default PagePwdReset;
